import { Component } from '@angular/core';

/**
 * Route host for the full-page Arya experience (/arya).
 *
 * Renders the SAME chat component as the floating/docked window, in page mode,
 * inside the app content area — so the sidebar and top header stay visible and
 * history + behaviour are identical across the docked and full-page surfaces.
 */
@Component({
  selector: 'codemiro-arya-page',
  template: `<codemiro-arya-chat [pageMode]="true"></codemiro-arya-chat>`,
  styles: [':host { display: block; height: 100%; }'],
})
export class AryaPageComponent {}
